import axios from "axios";
import { ROUTES } from "./constants/routes";
import "./utils/authStorage";

function isAuthProblem(err: any): boolean {
  const status = err?.response?.status;
  const msg = String(err?.response?.data?.errorMsg || err?.message || "").toLowerCase();
  return (
    status === 401 ||
    msg.includes("jwt malformed") ||
    msg.includes("jwt expired") ||
    msg.includes("invalid token") ||
    msg.includes("invalid user token") ||
    msg.includes("authtoken not found") ||
    msg.includes("not authorized") ||
    msg.includes("unauthorized") ||
    msg.includes("user not allowed") ||
    msg.includes("account has been disabled")
  );
}

function redirectToLoginOnce() {
  try {
    if (window.location.hash === `#${ROUTES.login}` || window.location.hash === "#/") {
      return;
    }
    sessionStorage.clear();
    window.location.hash = `#${ROUTES.login}`;
    window.location.reload();
  } catch {
    window.location.href = `#${ROUTES.login}`;
  }
}

let installed = false;

export function installAxiosInterceptors() {
  if (installed) return;
  installed = true;

  // Always attach this tab's admin token (namespaced) so admin/staff never cross-send JWTs.
  axios.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (isAuthProblem(err)) {
        redirectToLoginOnce();
      }
      return Promise.reject(err);
    }
  );

  // NOTE: Do NOT logout on pagehide/tab switch. School admin and staff often run in
  // parallel tabs on the same origin; auto-logout caused session conflicts ("User not allowed").
}
